import * as React from "react";
const ImageIcon = (props) => (
  <svg
    width={111}
    height={111}
    viewBox="0 0 111 111"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M81.3982 36.7578H18.6562C14.8476 36.7578 11.75 39.8437 11.75 43.664V86.309C17.4961 82.3637 31.879 72.481 37.648 68.516L16.355 52.965V43.6642C16.355 42.3908 17.398 41.3634 18.6558 41.3634H81.3938C82.6672 41.3634 83.6946 42.3907 83.6946 43.6642V87.5822L59.9916 64.1252C58.1049 62.2814 55.1557 62.0393 53.0228 63.5276C41.8428 71.2151 23.6598 83.6916 12.4058 91.4496C13.5308 93.8324 15.9956 95.4143 18.6519 95.4104H22.9058H78.5228H81.3939C85.2025 95.4104 88.3001 92.3089 88.3001 88.5043V43.6643C88.3001 39.8401 85.1985 36.7581 81.3939 36.7581L81.3982 36.7578Z"
      fill="#969EAA"
    />
    <path
      d="M26.5156 30.418H37.2616C40.285 30.3711 40.2928 25.8594 37.2616 25.8125H26.5156C23.4922 25.8594 23.4844 30.3711 26.5156 30.418Z"
      fill="#969EAA"
    />
    <path
      d="M48.0078 30.418H58.7538C61.7772 30.3711 61.785 25.8594 58.7538 25.8125H48.0078C44.9844 25.8594 44.9766 30.3711 48.0078 30.418Z"
      fill="#969EAA"
    />
    <path
      d="M96.9492 43.3047C95.6758 43.3047 94.6484 44.332 94.6484 45.6055V56.3515C94.6953 59.3749 99.207 59.3827 99.2539 56.3515V45.6055C99.2539 44.3321 98.2266 43.3047 96.9531 43.3047H96.9492Z"
      fill="#969EAA"
    />
    <path
      d="M69.5 30.418H80.246C83.2694 30.3711 83.2772 25.8594 80.246 25.8125H69.5C66.4766 25.8594 66.4688 30.3711 69.5 30.418Z"
      fill="#969EAA"
    />
    <path
      d="M92.3711 25.8047H90.9882C87.9609 25.8555 87.9609 30.3594 90.9882 30.4102H92.3711C93.6289 30.4102 94.6445 31.4219 94.6445 32.6836V34.8633C94.6445 36.1367 95.6717 37.1641 96.9452 37.1641C98.2186 37.1641 99.2461 36.1368 99.2461 34.8633V32.6836C99.2461 28.8906 96.1602 25.8047 92.3672 25.8047H92.3711Z"
      fill="#969EAA"
    />
    <path
      d="M96.9492 64.7969C95.6758 64.7969 94.6484 65.8242 94.6484 67.0977V77.8437C94.6953 80.8671 99.207 80.8749 99.2539 77.8437V67.0977C99.2539 65.8243 98.2266 64.7969 96.9531 64.7969H96.9492Z"
      fill="#969EAA"
    />
    <path
      d="M49.4527 53.8828C49.4527 49.5234 45.9058 45.9609 41.5465 45.9609C31.0895 46.3359 31.0775 61.4179 41.5465 61.7889C45.9059 61.7889 49.4527 58.2421 49.4527 53.8828Z"
      fill="#969EAA"
    />
  </svg>
);
export default ImageIcon;
